import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-date-input',
    templateUrl: './date-input.component.html',
    styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent implements OnInit {
    isFocus = false;

    @Input() formGroup: FormGroup;
    @Input() hasLabel = true;
    @Input() groupLabel = '';

    constructor() { }

    ngOnInit() {
    }

    onFocus(e) {
        this.isFocus = true;
    }

    onBlur(input) {
        this.isFocus = false;
        // this.validateDateinput();
    }

    validateDateinput() {
        this.sanitizeDateInput();

        const inputMonth = this.formGroup.get('month').value;
        const inputDay = this.formGroup.get('day').value;
        const inputYear = this.formGroup.get('year').value;


        const dateInput: Date = this.makeDateFromInput(inputMonth, inputDay, inputYear);
        if ((inputDay !== '' && inputYear !== '' && inputMonth !== '') && ((dateInput.getMonth() + 1) !== Number(inputMonth)) ) {
            // get max value of the input month
            const maxDateHolder = new Date(inputYear, inputMonth, 0);
            if (maxDateHolder.getDate()) {
                this.formGroup.get('day').setValue(maxDateHolder.getDate());
            }
        }
    }

    // Sanitize Values
    private getInputValues () {
        const month = Number(this.formGroup.get('month').value);
        const day = Number(this.formGroup.get('day').value);
        const year = Number(this.formGroup.get('year').value);

        return {
            month,
            year,
            day,
        };
    }

    sanitizeDateValue () {
        const inputValues = this.getInputValues();
        // Correct day input
        if (inputValues.day !== 0) {
            if (Number(inputValues.day) > 31) {
                // if month is not empty then max day set to 31
                this.formGroup.get('day').setValue(31);
            }

            if (Number(inputValues.day) < 10) {
                this.formGroup.get('day').setValue('0' + inputValues.day);
            }

            // Validate if exceed to max date
            if (inputValues.month > 0 && inputValues.month <= 12) {
                let _year = inputValues.year;
                if (Number(_year) <= 999 || Number(_year) > (new Date()).getFullYear()) {
                    _year = (new Date()).getFullYear();
                }

                const tmpDateValidator = new Date(_year, inputValues.month, 1);
                tmpDateValidator.setDate(-1);
                const maxDate = tmpDateValidator.getDate() + 1;
                if (maxDate < inputValues.day) {
                    this.formGroup.get('day').setValue(maxDate);
                }
            }
        }

        if (Number(inputValues.day) < 1) {
            this.formGroup.get('day').setValue('');
        }

    }

    sanitizeMonthValue () {
        const inputValues = this.getInputValues();

        // Correct month input
        if (inputValues.month !== 0) {
            if (inputValues.month > 12) {
                this.formGroup.get('month').setValue('12');
            }

            if (inputValues.month < 10) {
                this.formGroup.get('month').setValue('0' + inputValues.month);
            }

        }

        if (inputValues.month < 1) {
            this.formGroup.get('month').setValue('');
        }

        this.sanitizeDateValue();
    }

    sanitizeYearValue () {
        const inputValues = this.getInputValues();

        // Correct year value
        if (inputValues.year !== 0) {
            if (Number(inputValues.year) > (new Date()).getFullYear() || Number(inputValues.year) < 999) {
                this.formGroup.get('year').setValue('');
            }
        }

        if (inputValues.year < 1) {
            this.formGroup.get('year').setValue('');
        }

        this.sanitizeDateValue();
    }
    // Sanitize Values

    showLabel() {
        const month = this.formGroup.get('month').value;
        const day = this.formGroup.get('day').value;
        const year = this.formGroup.get('year').value;
        if ( (month !== '' || day !== '' || year !== '') || this.isFocus === true) {
            return true;
        }
        return false;
    }

    onPaste(str) {
        // const date = new Date(str);
        // if (Boolean(+date)) {
        //     const monthFromDate = date.getMonth() + 1;
        //     const month = (monthFromDate < 10) ? '0' + String(monthFromDate) : monthFromDate;
        //     this.formGroup.get('month').setValue(month);
        //     this.formGroup.get('day').setValue(date.getDate());
        //     this.formGroup.get('year').setValue(date.getFullYear());
        // }
    }

    getDateValue (formatted = false): Date|string {
        const currentValues = this.getInputValues();
        const invalid = Object.keys(currentValues).some(key => {
            return Number(currentValues[key]) === 0;
        });

        if (!invalid) {
            const birthDate = new Date(currentValues.year, Number(currentValues.month) - 1, currentValues.day);
            if (formatted) {
                return `${currentValues.year}-${currentValues.month}-${currentValues.day}`;
            }
            return birthDate;
        }
        if (formatted) {
            return '';
        }
        return null;
    }

    private makeDateFromInput(month, day, year): Date {
        const date = new Date();
        date.setMonth(Number(month) - 1);
        if (day !== '') {
            date.setDate(day);
        }
        if (year !== '') {
            date.setFullYear(year);
        }

        return date;
    }

    private sanitizeDateInput() {
        const inputMonth = this.formGroup.get('month').value;
        const inputDay = this.formGroup.get('day').value;
        const inputYear = this.formGroup.get('year').value;

        // Correct month input
        if (inputMonth !== '') {
            if (Number(inputMonth) > 12) {
                this.formGroup.get('month').setValue('12');
            }

            if (Number(inputMonth) < 10) {
                this.formGroup.get('month').setValue('0' + Number(inputMonth));
            }

            if (Number(inputMonth) < 1) {
                this.formGroup.get('month').setValue('');
            }
        }

        // Correct day input
        if (inputDay !== '') {
            if (Number(inputDay) > 31) {
                // if month is not empty then max day set to 31
                this.formGroup.get('day').setValue(31);
            }

            if (Number(inputDay) < 10) {
                this.formGroup.get('day').setValue('0' + Number(inputDay));
            }

            if (Number(inputDay) < 1) {
                this.formGroup.get('day').setValue('');
            }
        }

        // Correct year value
        if (inputYear !== '') {
            if (Number(inputYear) > (new Date()).getFullYear() || Number(inputYear) < 999) {
                this.formGroup.get('year').setValue('');
            }

            if (Number(inputYear) < 1) {
                this.formGroup.get('year').setValue('');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/date-input/date-input.component.ts